import React from "react";

import {
  Box,
  Button,
  Chip,
  Grid,
  Paper,
  Typography
} from "@material-ui/core";

import {
  CropFree,
  WhatsApp
} from "@material-ui/icons";

const ConnectionMethodCards = ({
  canAddAnotherWhatsapp,
  connectionLimit,
  connectionsInUse,
  onConnectQrCode,
  onConnectOfficial
}) => {
  return (
    <Paper
      id="connection-method-cards"
      variant="outlined"
      style={{
        flexShrink: 0,
        padding: 18,
        borderRadius: 18,
        border: "1px solid rgba(15,23,42,.09)",
        background: "#FFFFFF",
        boxShadow: "0 8px 24px rgba(15,23,42,.06)"
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
        flexWrap="wrap"
        gridGap={10}
        style={{ marginBottom: 16 }}
      >
        <Box>
          <Typography
            style={{
              color: "#0F172A",
              fontSize: "0.95rem",
              fontWeight: 900
            }}
          >
            Conectar novo WhatsApp
          </Typography>

          <Typography
            color="textSecondary"
            style={{
              marginTop: 3,
              fontSize: "0.73rem"
            }}
          >
            Escolha entre conexão rápida via QR Code ou API Oficial da Meta.
          </Typography>
        </Box>

        <Chip
          size="small"
          label={
            connectionLimit > 0
              ? `${connectionsInUse} de ${connectionLimit} conexões`
              : `${connectionsInUse} conexões em uso`
          }
          style={{
            color: "#1D4ED8",
            background: "#EFF6FF",
            border: "1px solid rgba(37,99,235,.14)",
            fontWeight: 800
          }}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box
            style={{
              height: "100%",
              padding: 18,
              borderRadius: 16,
              border: "1px solid rgba(34,197,94,.20)",
              background:
                "linear-gradient(145deg,#F0FDF4,#FFFFFF)"
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              style={{ gap: 12 }}
            >
              <Box
                style={{
                  width: 46,
                  height: 46,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 14,
                  color: "#FFFFFF",
                  background:
                    "linear-gradient(135deg,#22C55E,#059669)",
                  boxShadow:
                    "0 8px 18px rgba(34,197,94,.20)"
                }}
              >
                <CropFree />
              </Box>

              <Box>
                <Typography
                  style={{
                    color: "#0F172A",
                    fontSize: "0.9rem",
                    fontWeight: 900
                  }}
                >
                  WhatsApp via QR Code
                </Typography>

                <Typography
                  color="textSecondary"
                  style={{
                    marginTop: 2,
                    fontSize: "0.7rem"
                  }}
                >
                  Conexão rápida com o WhatsApp Business instalado.
                </Typography>
              </Box>
            </Box>

            <Typography
              color="textSecondary"
              style={{
                minHeight: 42,
                marginTop: 14,
                fontSize: "0.72rem",
                lineHeight: 1.55
              }}
            >
              Escaneie o QR Code com o celular e comece a usar a Korax em poucos minutos.
            </Typography>

            <Button
              fullWidth
              variant="contained"
              onClick={
                canAddAnotherWhatsapp
                  ? onConnectQrCode
                  : undefined
              }
              disabled={!canAddAnotherWhatsapp}
              style={{
                minHeight: 40,
                marginTop: 15,
                borderRadius: 10,
                color: "#FFFFFF",
                background: canAddAnotherWhatsapp
                  ? "linear-gradient(135deg,#22C55E,#059669)"
                  : "#94A3B8",
                boxShadow: canAddAnotherWhatsapp
                  ? "0 8px 18px rgba(34,197,94,.18)"
                  : "none",
                fontWeight: 850,
                textTransform: "none"
              }}
            >
              {canAddAnotherWhatsapp
                ? "Conectar via QR Code"
                : "Limite de conexões atingido"}
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            style={{
              height: "100%",
              padding: 18,
              borderRadius: 16,
              border: "1px solid rgba(37,99,235,.22)",
              background:
                "linear-gradient(145deg,#EFF6FF,#FFFFFF)",
              boxShadow:
                "0 8px 22px rgba(37,99,235,.06)"
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{ gap: 10 }}
            >
              <Box
                display="flex"
                alignItems="center"
                style={{ gap: 12 }}
              >
                <Box
                  style={{
                    width: 46,
                    height: 46,
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 14,
                    color: "#FFFFFF",
                    background:
                      "linear-gradient(135deg,#2563EB,#4F46E5)",
                    boxShadow:
                      "0 8px 18px rgba(37,99,235,.22)"
                  }}
                >
                  <WhatsApp />
                </Box>

                <Box>
                  <Typography
                    style={{
                      color: "#0F172A",
                      fontSize: "0.9rem",
                      fontWeight: 900
                    }}
                  >
                    WhatsApp Business API
                  </Typography>

                  <Typography
                    color="textSecondary"
                    style={{
                      marginTop: 2,
                      fontSize: "0.7rem"
                    }}
                  >
                    API Oficial da Meta.
                  </Typography>
                </Box>
              </Box>

              <Chip
                size="small"
                label="Recomendado"
                style={{
                  color: "#1D4ED8",
                  background: "#DBEAFE",
                  fontSize: "0.62rem",
                  fontWeight: 900
                }}
              />
            </Box>

            <Typography
              color="textSecondary"
              style={{
                minHeight: 42,
                marginTop: 14,
                fontSize: "0.72rem",
                lineHeight: 1.55
              }}
            >
              Operação sem QR Code, maior estabilidade e estrutura oficial para empresas e equipes.
            </Typography>

            <Button
              fullWidth
              variant="contained"
              onClick={
                canAddAnotherWhatsapp
                  ? onConnectOfficial
                  : undefined
              }
              disabled={!canAddAnotherWhatsapp}
              style={{
                minHeight: 40,
                marginTop: 15,
                borderRadius: 10,
                color: "#FFFFFF",
                background: canAddAnotherWhatsapp
                  ? "linear-gradient(135deg,#2563EB,#4F46E5)"
                  : "#94A3B8",
                boxShadow: canAddAnotherWhatsapp
                  ? "0 8px 18px rgba(37,99,235,.20)"
                  : "none",
                fontWeight: 850,
                textTransform: "none"
              }}
            >
              {canAddAnotherWhatsapp
                ? "Conectar API Oficial"
                : "Limite de conexões atingido"}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ConnectionMethodCards;
